export const KRA_DOCUMENTS_REQUIRED_COUNT = 2;
